<h2 mat-dialog-title>Switch User</h2>

<mat-dialog-content>

  <!-- Row: Dropdown + Switch Button -->
  <div class="row align-items-end">
    
    <!-- Dropdown -->
    <div class="col-md-12">
      <mat-form-field appearance="fill" class="w-100">
        <mat-select #selectUsers
          [(value)]="userState.selected"
          (selectionChange)="onUserChange($event.value)"
        >
          <!-- Search -->
          <mat-option>
            <ngx-mat-select-search
              [formControl]="userNameSearchControl"
              placeholderLabel="Search User Name..."
              noEntriesFoundLabel="No results">
            </ngx-mat-select-search>
          </mat-option>

          @if (!userState.loading || userState.data.length > 0) {
            <mat-option value="All">All Users</mat-option>
          }

          @for (user of userState.data; track user.id) {
            <mat-option [value]="user.id">
              {{ user.name | titlecase }}
            </mat-option>
          }

          <!-- Loading states -->
          @if (userState.loading) {
            <mat-option class="loading-option" disabled>
              <div class="d-flex align-items-center justify-content-center">
                <mat-spinner diameter="20" class="me-2"></mat-spinner>
                <span>{{ userState.data.length ? 'Loading more...' : 'Loading...' }}</span>
              </div>
            </mat-option>
          }

          @if (!userState.loading && userState.data.length === 0) {
            <mat-option disabled>
              <div class="text-center w-100">
                No Data Found...
              </div>
            </mat-option>
          }

        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" class="w-100" (click)="onSwitch()">
        <mat-icon>swap_horiz</mat-icon>
        Switch
      </button>
    </div>

    <!-- Switch Button (beside dropdown) -->
    <!-- <div class="col-md-4">
      <button mat-raised-button color="primary" class="w-100">
        <mat-icon>swap_horiz</mat-icon>
        Switch
      </button>
    </div> -->

  </div>

  <!-- OR Divider -->
  <div class="or-divider">
    <span>OR</span>
  </div>

  <!-- My Drive -->
  <button mat-raised-button class="drive-btn w-100" (click)="onMyDrive()">
    <mat-icon class="me-1">folder</mat-icon>
    My Drive
  </button>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>